import ChildOne from "../views/assets/avatars/child/child-01.svg";
import ChildTwo from "../views/assets/avatars/child/child-02.svg";
import ChildThree from "../views/assets/avatars/child/child-03.svg";
import ChildFour from "../views/assets/avatars/child/child-04.svg";
import ChildFive from "../views/assets/avatars/child/child-05.svg";
import ChildSix from "../views/assets/avatars/child/child-06.svg";

import ParentOne from "../views/assets/avatars/parent/parent-01.svg";
import ParentTwo from "../views/assets/avatars/parent/parent-02.svg";
import ParentThree from "../views/assets/avatars/parent/parent-03.svg";
import ParentFour from "../views/assets/avatars/parent/parent-04.svg";
import ParentFive from "../views/assets/avatars/parent/parent-05.svg";
import ParentSix from "../views/assets/avatars/parent/parent-06.svg";

const AVATARS = {
  children: [ChildOne, ChildTwo, ChildThree, ChildFour, ChildFive, ChildSix],
  parents: [
    ParentOne,
    ParentTwo,
    ParentThree,
    ParentFour,
    ParentFive,
    ParentSix,
  ],
};

export default AVATARS;
